import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserIdentityService } from '@shared/core/user-identity.service';
import { AttributeEditor } from '@shared/model/attribute-editor';
import { Resources } from '@shared/model/permissions';
import { Stage } from '@shared/model/stage';
import { StageItemCount } from '@shared/model/stage-item-count';
import { AttributeEditorService } from '@shared/services/attribute-editor.service';
import { ItemService } from '@shared/services/item.service';
import { StageService } from '@shared/services/stage.service';
import { SharedModule } from '@shared/shared.module';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-my-tasks',
  templateUrl: './my-tasks.component.html',
  styleUrls: ['./my-tasks.component.scss'],
  imports:[ CommonModule,SharedModule]
})
export class MyTasksComponent implements OnInit {

  myStages!: Stage[];
  myEditors!:AttributeEditor[];
  itemCounts: number[];
  loadingCount:boolean=true;

  myEditorsMenuItems:MenuItem[]=[];
  hasWorkflowPermission: boolean=false;
  hasEditorPermission: boolean=false;
  constructor(private stageService: StageService,
    private attributeEditorService :AttributeEditorService,
    private itemService: ItemService,
    private userIdentityService:UserIdentityService,
    private router: Router) { 
      this.itemCounts= new Array<number>();
    }

  ngOnInit() {
    this.getMyStages();
    this.getMyEditors();
    this.hasWorkflowPermission= this.hasPermission(Resources.Workflow);
    this.hasEditorPermission= this.hasPermission(Resources.AttributeEditWindows);
   // this.myEditorsMenuItems.push({label:'test'})
  }
  getMyStages() {
    this.stageService.getMyStages()
      .subscribe(stages => {
        this.myStages = stages;
        this.getItemCounts();
      });
  }
  // getMyEditors() {
  //   this.attributeEditorService.getMyEditors()
  //     .subscribe(stages => {
  //       this.myEditors = stages;
  //       //this.getItemCounts();
  //     });
  // }
  navigateToStage(stage: Stage) {
    this.router.navigate(['/inventory/stageitems', stage.id]);
  }
  navigateToEditor(editor:AttributeEditor){
    this.router.navigate(['/inventory/attributeeditor', editor.id,"null"]);
  }
  getItemCounts() {
    this.loadingCount=true;
    this.itemService.getCountsByStage(this.myStages.map(a => a.id))
      .subscribe(a => {
        a.forEach((result: StageItemCount) => this.itemCounts[result.stageId] = result.count);
        this.loadingCount=false;
      });

  }
  getMyEditors(){
    this.attributeEditorService.getMyEditors()
    .subscribe(editors => {
      this.myEditors=editors;
      // if (editors){
      //   editors.forEach((editor)=>{
      //     this.myEditorsMenuItems.push({
      //        label: editor.name, icon:'fa fa-edit', command: (event) => this.gotoEditor(editor.id) 
      //     });
      //   })
      // }
    });
  }
  gotoEditor(editorId:string|number){
    this.router.navigate(['/inventory/attributeeditor', editorId,'null']);
  }
  gotoEditorSettings(){
    this.router.navigate(['/housekeeping/attributeeditwindows']);
  }
  gotoWorkflowSettings() {
    this.router.navigate(['/housekeeping/workflow']);
  }
  hasPermission(resource: Resources) {
          // debugger;
          var resourceItem = this.userIdentityService.currentPermissionValue?.find(a => a.resource == resource);
          // debugger;
          return !!resourceItem;
          // return false;
      }

}
